/** Remote Control application payloads carried by the BPP request and response envelopes. */
export const SESSION_CONTROL_CAPABILITY = 'session_control_v1';
export const SESSION_CONTROL_ACTION = 'session_control';
export const SESSION_CONTROL_VERSION = 1;
export const SESSION_CONTROL_MAX_BYTES = 32768;
export const SESSION_CONTROL_DIRECTORY_MAX_BYTES = 131072;
export const SESSION_INPUT_CAPABILITY = 'session_input_v1';
export const SESSION_INPUT_STEER_CAPABILITY = 'session_input_steer_v1';
export const SESSION_INPUT_NEXT_TURN_CAPABILITY = 'session_input_next_turn_v1';
export const SESSION_INPUT_START_TURN_CAPABILITY = 'session_input_start_turn_v1';
export const SESSION_CONTROL_RECEIPTS_CAPABILITY = 'session_control_receipts_v1';
//# sourceMappingURL=session-control-types.js.map